export interface IDataLParams {
    [key: string]: string | number
}

export class DataL {
    static attrName = "data-log-click";

    static attr(params?: IDataLParams | string) {
        return params
            ? { [DataL.attrName]: typeof params === "string" ? params : JSON.stringify(params) }
            : {};
    }

    static target(name: string) {
        return DataL.attr({
            "target": name
        });
    }

    static targetId(name: string) {
        return DataL.attr({
            "targetId": name
        });
    }
}
